import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default new (class {
	async getAllCareerClusters(facilityId) {
		const response = await axios.get(
			`${API_URL}/api/Cms/CareerClusters?facilityId=${facilityId}`,
			{
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			}
		);
		return response.data;
	}
	async getCareerById(careerId) {
		const url = careerId
			? `/api/Cms/Career?careerId=${careerId}`
			: '/api/Cms/Career';

		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async getCareerJobTitlesById(careerId) {
		const url = careerId
			? `/api/Cms/CareerJobTitles?careerId=${careerId}`
			: '/api/Cms/CareerJobTitles';

		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async updateCluster(careerCluster) {
		try {
			await axios.put(`${API_URL}/api/Cms/CareerCluster`, careerCluster, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error updating simulation template:', error);
			throw error;
		}
	}
	async update(career, facilityID) {
		try {
			await axios.put(
				`${API_URL}/api/Cms/Career?facilityId=${facilityID}`,
				career,
				{
					withCredentials: true,
					headers: {
						'Cache-control': 'no-cache'
					}
				}
			);
		} catch (error) {
			console.error('Error updating simulation template:', error);
			throw error;
		}
	}
	async deleteById(careerId) {
		try {
			await axios.delete(`${API_URL}/api/Cms/Career?careerId=${careerId}`, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error deleting by ID:', error);
			throw error;
		}
	}
})();
